import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=2023f8f6&scoped=true&"
import script from "./Competitors.vue?vue&type=script&lang=js&"
export * from "./Competitors.vue?vue&type=script&lang=js&"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=2023f8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023f8f6",
  null
  
)

export default component.exports